module.exports = __webpack_public_path__ + "public/img/icon_yingxiao.9519b6cd.png";